import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { PaymentsEffects } from './payments.effects';
import { IPaymentsFeature } from './payments.feature.state';
import { paymentsReducer } from './payments.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<IPaymentsFeature>('paymentsFeature'), paymentsReducer),
    EffectsModule.forFeature([PaymentsEffects]),
  ],
})
export class PaymentsStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: PaymentsStateModule
  ) {
    if (parentModule) {
      throw new Error('PaymentsStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
